<template @keydown="onKeydown">
  <div class="ticket-detail">
    <div class="ticket-detail_val">
      <h2 class="ticket-detail__title">
        {{ getTranslatedText("ticket validation") }}
      </h2>
      <div class="ticket-detail__search">
        <label>{{ getTranslatedText("ticket code") }}</label>
        <div>
          <v-text-field ref="searchTextField" v-model="dataSearch" solo></v-text-field>
        </div>
        <ButtonCommon type="" ref="searchBtn" text="Search" class-name="ticket-detail__search__box-btn search"
          :isNoHover="true" @action-button="onSearch()" :isLoading="loadingButtonSearch" :isDisable="dataSearch === ''" />
        <span class="text-or">{{ getTranslatedText("or") }}</span>
        <ButtonCommon ref="scanBtn" type="" text="Scan ticket" class-name="ticket-detail__search__box-btn"
          :isNoHover="true" @action-button="onScanTicket()" :isLoading="loadingButtonScan" />
      </div>
      <div class="ticket-detail__content" v-if="ticketDetail">
        <p class="text-title">{{ getTranslatedText("ticket details") }}</p>
        <div class="content-main-detail">
          <div class="left">
            <div class="content content-top">
              <div class="content-left">
                <p class="text">{{ getTranslatedText("Purchase Date") }}:</p>
                <p class="text-value">
                  {{ $helpers.formatDateTime(ticketDetail.purchased_date) }}
                </p>
              </div>
              <div class="content-center">
                <p class="text">{{ getTranslatedText("Amount Played") }}:</p>
                <p class="text-value">
                  {{
                    getTranslatedText(CURRENCY) +
                    " " +
                    renderPrice(ticketDetail.total_wager)
                  }}
                </p>
              </div>
              <div class="content-right">
                <p class="text">{{ getTranslatedText("Ticket") }}:</p>
                <p class="text-value">{{ ticketDetail.reference }}</p>
              </div>
            </div>
            <div class="content content-bottom">
              <div class="content-left">
                <p class="text">{{ getTranslatedText("Draw Date & Time") }}:</p>
                <p class="text-value">
                  {{ $helpers.formatDateTime(ticketDetail.draw_date) }}
                  <!-- <div class="number" v-for="(data, inx) in ticketDetail.results" :key="inx">
                    {{ data }}
                  </div> -->
                </p>
              </div>
              <div class="content-center none_border-right">
                <p class="text">{{ getTranslatedText("ticket status") }}:</p>
                <p class="text-value">
                  {{ ticketDetail.status }}
                </p>
              </div>
              <div class="content-right">
                <!-- <p class="text">{{ getTranslatedText("Draw Status") }}:</p>
                <p class="text-value">{{ ticketDetail.draw_status }}</p> -->
              </div>
            </div>
          </div>
          <div class="right">
            <div class="head-value" v-if="!$store.state.isScreenMobile">
              <p class="cell-text no">{{ getTranslatedText("no") }}</p>
              <p class="cell-text select">{{ getTranslatedText("select") }}</p>
              <p class="cell-text game">{{ getTranslatedText("game") }}</p>
              <p class="cell-text bet_type">{{ getTranslatedText("bet type") }}</p>
              <p class="cell-text results">{{ getTranslatedText("results") }}</p>
              <p v-if="ticketDetail.bet_type === 'single'" class="cell-text results">{{ getTranslatedText("wager") }}</p>
              <p v-if="ticketDetail.bet_type === 'single'" class="cell-text results">{{ getTranslatedText("winnings") }}</p>
            </div>
            <div class="body-value" v-for="(item, index) in ticketDetail.bets" :key="index">
              <p class="cell-text no">
                <span v-if="$store.state.isScreenMobile">{{
                  getTranslatedText("no")
                }}</span>{{ "#" + (index + 1) }}
              </p>
              <p class="cell-text select">
                <span v-if="$store.state.isScreenMobile">{{
                  getTranslatedText("select")
                }}</span>{{ item.select.join() }}
              </p>
              <p class="cell-text game">
                <span v-if="$store.state.isScreenMobile">{{
                  getTranslatedText("game")
                }}</span>{{ item.game }}
              </p>
              <p class="cell-text bet_type">
                <span v-if="$store.state.isScreenMobile">{{
                  getTranslatedText("bet type")
                }}</span>{{ item.bet_type }}
              </p>
              <div class="cell-text results">
                <span v-if="$store.state.isScreenMobile">{{
                  getTranslatedText("results")
                }}</span>
                <ul>
                  <template v-for="(result, i) in item.results">
                    <li v-for="(number, index) in result" :key="index">
                      {{ number }}
                    </li>
                  </template>
                </ul>
              </div>
              <div v-if="ticketDetail.bet_type === 'single'" class="cell-text results">
                <span v-if="$store.state.isScreenMobile">{{
                  getTranslatedText("wager")
                }}</span>{{
  renderPrice(ticketDetail.total_wager)
}}
              </div>
              <div v-if="ticketDetail.bet_type === 'single'" class="cell-text results">
                <span v-if="$store.state.isScreenMobile">{{
                  getTranslatedText("winnings")
                }}</span><span v-if="ticketDetail.status === 'Cancelled'">{{ renderPrice(0) }}</span>
                <span v-else>{{ renderPrice(ticketDetail.unpaid_amount) }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="footer-content" v-if="ticketDetail.status !== 'Lose'">
          <template>
            <div>
              <p class="winnings">{{ getTranslatedText(textPayment) }}</p>
              <p class="payment" v-if="ticketDetail.unpaid_amount > 0">
                {{
                  getTranslatedText(`Make Payment ${CURRENCY}.`) +
                  renderPrice(ticketDetail.unpaid_amount)
                }}
              </p>
              <p class="payment" v-if="ticketDetail.paid_amount > 0">
                {{
                  getTranslatedText(`Made Payment ${CURRENCY}. `) +
                  renderPrice(ticketDetail.paid_amount)
                }}
              </p>
              <p class="payment"
                v-if="Number(ticketDetail.unpaid_amount) === 0 && Number(ticketDetail.paid_amount) === 0">
                {{
                  getTranslatedText(`Make Payment ${CURRENCY}. `) +
                  renderPrice(ticketDetail.unpaid_amount)
                }}
              </p>
            </div>
            <ButtonCommon type="" v-if="ticketDetail.unpaid_amount > 0" text="Validate"
              class-name="ticket-detail__search__box-btn" :isNoHover="true" @action-button="onValidate()"
              :isLoading="loadingButtonValidate" />
          </template>
        </div>
      </div>
      <div v-else class="ticket-detail__empty">
        {{ getTranslatedText(textEmptyData) }}
      </div>
    </div>
    <div class="ticket-detail__scan" v-if="$store.state.isScreenMobile && showScan">
      <!-- <div class="ticket-detail__scan--land" ref="cameraContainer"></div> -->
      <div class="ticket-detail__scan--content">
        <p>{{ getTranslatedText("scan ticket") }}</p>
        <ButtonCommon type="" text="Close" :isNoHover="true" @action-button="offScanTicket()" />
      </div>
    </div>
  </div>
</template>
<script>
import languageMixins from "@/mixins/language/language-mixins";
import errorDeviceMinxins from "@/mixins/errorDevice/errorDevice-mixins";
import printMixins from "@/mixins/print/print-mixins";
import ButtonCommon from "@/components/common/button";
import { getSettingDevice, formatPrice } from "@/utils/utils";
import EventBus from "@/utils/EventBus";
import TicketService from "@/services/ticket.service";
const MAXIMUM_PAYOUT = process.env.VUE_APP_MAXIMUM_PAYOUT;
const CURRENCY_SYMBOL = process.env.VUE_APP_CURRENCY_SYMBOL;
const PAYOUT_LIMIT = process.env.VUE_APP_PAYOUT_LIMIT;

export default {
  mixins: [languageMixins, errorDeviceMinxins, printMixins],
  components: { ButtonCommon },
  data() {
    return {
      dataSearch: "",
      ticketDetail: null,
      loadingButtonSearch: false,
      loadingButtonScan: false,
      loadingButtonValidate: false,
      showScan: false,
      textEmptyData:
        "Please enter or scan the ticket reference code to proceed with ticket detail.",
      cameraContainer: null,
      scannedCode: '',
      isScanning: false,
      device: getSettingDevice(),
      textPayment: '',
      maximumPayout: this.$store.state.configAccount?.cashier.max_payout ? this.$store.state.configAccount?.cashier.max_payout : MAXIMUM_PAYOUT,
      payoutLimit: this.$store.state.configAccount?.cashier.payout_limit_per_ticket ? this.$store.state.configAccount?.cashier.payout_limit_per_ticket : PAYOUT_LIMIT,
      CURRENCY: this.$store.state.configAccount?.settings.CURRENCY_SYMBOL ? this.$store.state.configAccount?.settings.CURRENCY_SYMBOL : CURRENCY_SYMBOL,
    };
  },
  mounted() {
    document.addEventListener('message', this.onDecode);
    this.cameraContainer = this.$refs.cameraContainer;
  },
  created() {
    window.addEventListener('keydown', this.onKeydown);
    EventBus.$on('hide-scan-dialog', () => {
      this.isScanning = false
    })
    EventBus.$on('on-hide-camere-scan', () => this.isShowScan = false)
  },
  beforeDestroy() {
    window.removeEventListener('keydown', this.onKeydown);
    EventBus.$off('hide-scan-dialog')
    EventBus.$off('on-hide-camere-scan')
  },
  methods: {
    async onSearch() {
      try {
        let dataSearch = this.dataSearch.trim();
        if (!this.dataSearch || this.dataSearch.trim() === '') {
          EventBus.$emit("on-show-notications", {
            title: 'Please input ticket code!',
            status: "error",
            description: "",
          });
          return
        }
        this.loadingButtonSearch = true;
        const res = await TicketService.ticketDetails(dataSearch);
        if (res.status === "success") {
          this.ticketDetail = res.data;
          this.loadingButtonSearch = false;
        } else {
          this.ticketDetail = null;
          this.textEmptyData = "No data";
          const param = {
            title: res.message,
            status: "error",
            description: "Please Try Again",
          };
          param.title = res.data?.errors
            ? res.data.errors.map(item => item.message).join(', ')
            : res.message;
          EventBus.$emit("on-show-notications", param);
          this.loadingButtonSearch = false;
        }
        this.checkErrorDevice(this.$router, res)
      } catch (error) {
        this.ticketDetail = null;
        this.textEmptyData = "No data";
        const param = {
          title: error.message,
          status: "error",
          description: "Please Try Again",
        };
        param.title = error.data?.errors
          ? error.data.errors.map(item => item.message).join(', ')
          : error.message;
        EventBus.$emit("on-show-notications", param);
        this.loadingButtonSearch = false;
        this.checkErrorDevice(this.$router, error)
        console.log(error);
      }
    },
    onKeydown(e) {
      if (!this.isScanning) { return }
      else {
        e.preventDefault()
      }

      if (e.key !== 'Enter') {
        this.scannedCode += e.key
      }
      else {
        this.isScanning = false
        this.dataSearch = `${this.scannedCode}`
        // this.scannedCode = ""
        EventBus.$emit("hide-notications")
        setTimeout(function () {
          // this.$refs.searchTextField.value = this.scannedCode
          this.$refs.scanBtn.$el.blur()
        }.bind(this), 200)
        return false
      }
    },
    onScanTicket() {
      // should check if device is having intergrated camera
      // and will use that camera to scan
      if (this.$store.state.isScreenMobile) {
        this.showScan = true;
        parent.postMessage({ command: 'is-show-cammera', param: this.showScan }, '*')
      }
      // external reader
      else {
        // this.dataSearch = ""
        this.scannedCode = ""
        // this.$refs.searchTextField.feocus()
        this.isScanning = true
        const params = {
          description: "Please Proceed To Scan Ticket Now",
          nameFunctionClose: 'hide-scan-dialog'
        };
        EventBus.$emit("on-show-notications", params);
      }
    },
    offScanTicket() {
      this.showScan = false;
      parent.postMessage({ command: 'is-show-cammera', param: false }, '*')
    },
    async onValidate() {
      const unpaidAmount = Number(this.ticketDetail.unpaid_amount);
      const isExceedPayoutLimit = Number(this.payoutLimit) > 0 && unpaidAmount > Number(this.payoutLimit);
      const isExceedMaximumPayout = unpaidAmount > Number(this.maximumPayout);

      if (isExceedPayoutLimit || isExceedMaximumPayout) {
        const param = {
          title: `Retailer is only allowed to pay up to <b>${this.CURRENCY} ${this.renderPrice(isExceedPayoutLimit ? this.payoutLimit : this.maximumPayout)} per ticket</b>, call support desk for more information`,
          status: "error",
        };
        EventBus.$emit("on-show-notications", param);
        return;
      }
      try {
        this.loadingButtonValidate = true;
        const res = await TicketService.ticketValidation(
          this.ticketDetail.reference
        );
        if (res.status === "success") {
          const param = {
            title: res.message ? res.message : "Successfully",
            status: "success",
          };
          EventBus.$emit("on-show-notications", param);
          this.loadingButtonValidate = false;
          // print only, missing other UI/UX flow
          // TODO: we may need REPRINT button on this ticket detail screen
          let printData = await this.prepareLogoAsSingleObject(res?.data?.printData);

          parent.postMessage({ command: 'print-settle', data: printData, defaultSunmiFont: this.$store.state.configAccount?.sunmiPrinterFont }, '*')
          this.onSearch()
        } else {
          const param = {
            title: res.message,
            status: "error",
            description: "Please Try Again",
          };
          param.title = res.data?.errors
            ? res.data.errors.map(item => item.message).join(', ')
            : res.message;
          EventBus.$emit("on-show-notications", param);
          this.loadingButtonValidate = false;
        }
        this.checkErrorDevice(this.$router, res)
        this.onSearch(this.ticketDetail.reference);
      } catch (error) {
        const param = {
          title: error.message,
          status: "error",
          description: "Please Try Again",
        };
        EventBus.$emit("on-show-notications", param);
        this.loadingButtonValidate = false;
        this.checkErrorDevice(this.$router, error)
        console.log(error);
      }
    },
    renderPrice(price) {
      return formatPrice(price);
    },
    onDecode(event) {
      const resp = JSON.parse(event.data);
      if (resp.command === 'on-decode-scan') {
        this.dataSearch = resp.data;
        // this.$refs.searchTextField.value = this.dataSearch
        this.showScan = false;
        parent.postMessage({ command: 'is-show-cammera', param: this.showScan }, '*')
      }
    }
  },
  watch: {
    ticketDetail() {
      switch (this.ticketDetail.status) {
        case 'Cancelled':
          this.textPayment = 'Refund'
          break;
        case 'Purchased':
          this.textPayment = 'Winnings'
          break;
        case 'Win':
          this.textPayment = 'Winnings'
          break;
        case 'Validated - Win':
          this.textPayment = 'Paid'
          break;
        case 'Validated - Cancel':
          this.textPayment = 'Paid'
          break;
      }
    },
    deep: true
  }
};
</script>
<style lang="scss">
@import "~ThemePath/scss/ticket-validation-detail/_index.scss";
</style>
